import store from "store/store.js";
import generic_backend_request_post from 'functions/server/generic_backend_request_post';
import getLocations, {getTravelCosts, getCostSettings, getVehicleTypes} from 'store/functions/openapi_conversion_functions.js';
import ProcessUploadedTravelCostRequest from "open-api-gen/model/ProcessUploadedTravelCostRequest.js";

async function process_uploaded_travel_costs({uploadedData, overwriteExisting=false}={}) {
    if (!uploadedData) {
        throw new Error('Uploaded data is required for process_uploaded_travel_costs');
    }
    if (!Array.isArray(uploadedData)) {
        throw new Error('Uploaded data must be an array');
    }

    const state = store.getState().inputData.present;
    const locations = getLocations(state);
    const vehicleTypes = getVehicleTypes(state);
    const travelCosts = getTravelCosts(state);
    const costSettings = getCostSettings(state);
    const request = ProcessUploadedTravelCostRequest.constructFromObject({
        UploadedData: uploadedData,
        Locations: locations,
        VehicleTypes: vehicleTypes,
        TravelCosts: travelCosts,
        CostSettings: costSettings,
        overwriteExistingEntries: overwriteExisting
    });
    const retJson = await generic_backend_request_post(request, '/process_uploaded_travel_costs');
    return retJson;
}

export default process_uploaded_travel_costs
